import { CreateCustomPageInput, CustomPage } from "@functions-types";
import { isNonNullish } from "@lib/utils";

export const customPageToInput = (customPage: CustomPage): CreateCustomPageInput => ({
  name: customPage.name,
  content: customPage.content,
  customFields: customPage.customFields.filter(isNonNullish).map(({ id }) => id),
});
